import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { TermsComponent } from "./terms/terms.component";
import { AuthModule } from "./auth/auth.module";
import { BaseModule } from "./base/base.module";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NavigationModule } from "./navigation/navigation.module";
import { CarouselModule } from "ngx-owl-carousel-o";
import { ToastrModule } from "ngx-toastr";
import { StripeModule } from "stripe-angular";
import { StripeComponent } from "./stripe/stripe.component";
import { Ng2TelInputModule } from "ng2-tel-input";
import { MyAccountModule } from "./my-account/my-account.module";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { environment } from "./../environments/environment";
import { ContactusComponent } from "./contactus/contactus.component";
import { RecaptchaModule } from "angular-google-recaptcha";
import { AppService } from "./app.service";
import { NgxSpinnerModule } from "ngx-spinner";
import { SocialLoginModule } from "angularx-social-login";
import { LoginComponent } from "./auth/login/login.component";
import { SignupComponent } from "./auth/signup/signup.component";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password.component";
import { OtpComponent } from "./auth/otp/otp.component";
import { PersonalInformationComponent } from "./auth/personal-information/personal-information.component";
import { SocialAuthServiceConfig } from "angularx-social-login";
import {
  GoogleLoginProvider,
  FacebookLoginProvider,
} from "angularx-social-login";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { NgOtpInputModule } from "ng-otp-input";
import { SubscriptionComponent } from "./subscription/subscription.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatRadioModule } from "@angular/material/radio";
import { PipeModule } from "./pipemodule/pipe.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { FaqComponent } from "./faq/faq.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { ValidateEqualModule } from "ng-validate-equal";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CodeOfConductComponent } from "./code-of-conduct/code-of-conduct.component";
import { RefundPolicyComponent } from "./refund-policy/refund-policy.component";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";
import { LandingComponent } from "./landing/landing.component";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
  declarations: [
    AppComponent,
    PrivacyPolicyComponent,
    TermsComponent,
    StripeComponent,
    ContactusComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    OtpComponent,
    PersonalInformationComponent,
    SubscriptionComponent,
    FaqComponent,
    CodeOfConductComponent,
    RefundPolicyComponent,
    DisclaimerComponent,
    LandingComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    BaseModule,
    MatDialogModule,
    BrowserAnimationsModule,
    NavigationModule,
    CarouselModule,
    MatDialogModule,
    MatExpansionModule,
    BsDropdownModule,
    BsDropdownModule.forRoot(),
    ToastrModule.forRoot({
      preventDuplicates: true,
      timeOut: 5000,
      closeButton: true,
    }),
    StripeModule.forRoot(environment.publicKey),
    Ng2TelInputModule,
    MyAccountModule,
    NgxSpinnerModule,
    RecaptchaModule.forRoot({
      siteKey: environment.reCaptchaKey,
    }),
    SocialLoginModule,
    HttpClientModule,
    NgOtpInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRippleModule,
    MatRadioModule,
    PipeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ValidateEqualModule,
  ],
  providers: [
    AppService,
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.googleClientId),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(environment.facebookAppId),
          },
        ],
      } as SocialAuthServiceConfig,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
